import React, { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  /** Дополнительные элементы справа (кнопки, фильтры и т.д.) */
  actions?: ReactNode;
}

/**
 * Единый заголовок страницы.
 * Используется на всех admin-страницах и пользовательских.
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, actions }) => (
  <div className="page-header">
    <h1 className="page-header__title">{title}</h1>
    {actions && <div className="page-header__actions">{actions}</div>}
  </div>
);

export default PageHeader;
